module.exports = __webpack_public_path__ + "img/gibraltar.dde48240.jpg";